function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoMentions = /*#__PURE__*/function () {
  function SaitoMentions(app, ref, menuRef, inputType) {
    _classCallCheck(this, SaitoMentions);
    this.app = app;
    this.ref = ref;
    this.menuRef = menuRef;
    this.options = [];
    this.inputType = inputType;
    this.closeMenu = this.closeMenu.bind(this);
    this.onInput = this.onInput.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.renderMenu = this.renderMenu.bind(this);
    this.ref.addEventListener('input', this.onInput);
    this.ref.addEventListener('keydown', this.onKeyDown);
    this.properties = ['direction', 'boxSizing', 'width', 'height', 'overflowX', 'overflowY', 'borderTopWidth', 'borderRightWidth', 'borderBottomWidth', 'borderLeftWidth', 'borderStyle', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft', 'fontStyle', 'fontVariant', 'fontWeight', 'fontStretch', 'fontSize', 'fontSizeAdjust', 'lineHeight', 'fontFamily', 'textAlign', 'textTransform', 'textIndent', 'textDecoration', 'letterSpacing', 'wordSpacing', 'tabSize', 'MozTabSize'];
    this.isFirefox = typeof window !== 'undefined' && window['mozInnerScreenX'] != null;
  }
  return _createClass(SaitoMentions, [{
    key: "closeMenu",
    value: function closeMenu() {
      var _this = this;
      setTimeout(function () {
        _this.options = [];
        _this.triggerIdx = undefined;
        _this.renderMenu();
      }, 0);
    }
  }, {
    key: "selectItem",
    value: function selectItem(active) {
      var text = '';
      if (this.inputType == 'div') {
        text = this.ref.innerText;
      } else {
        text = this.ref.value;
      }
      var preMention = text.substr(0, this.triggerIdx);
      var option = this.options[active];
      var trigger = '';
      if (!option) {
        console.log('Null Items, nope out');
        this.closeMenu();
        this.ref.focus();
        return;
      }
      if (this.inputType == 'div') {
        trigger = this.ref.innerText[this.triggerIdx];
      } else {
        trigger = this.ref.value[this.triggerIdx];
      }
      var mention = option !== null && option !== void 0 && option.identifier ? "".concat(trigger).concat(option.identifier, " ") : "".concat(trigger).concat(option.publicKey, " ");
      var selectionStart = null;
      if (this.inputType == 'div') {
        if (typeof window.getSelection != 'undefined') {
          var sel = window.getSelection();
          console.log(sel);
          sel.modify('extend', 'backward', 'word');
          var pos = sel.toString().length;
          if (sel.anchorNode != undefined) sel.collapseToEnd();
          selectionStart = pos + (mention.length - 1);
        }
      } else {
        selectionStart = this.ref.selectionStart;
      }
      //console.log('selection:', selectionStart);

      var postMention = text.substr(selectionStart);
      var newValue = "".concat(preMention).concat(mention).concat(postMention);

      // console.log('${preMention}: ', preMention);
      // console.log('${mention}: ', mention);
      // console.log('${postMention}: ', postMention);
      // console.log('newValue:', newValue);

      // console.log('inputType:', this.inputType);
      var caretPosition = 0;
      if (this.inputType == 'div') {
        this.ref.innerText = newValue;
        caretPosition = selectionStart;
      } else {
        this.ref.value = newValue;
        caretPosition = this.ref.value.length - postMention.length;
      }
      console.log('caretPosition:', caretPosition);
      if (this.inputType != 'div') {
        this.ref.setSelectionRange(caretPosition, caretPosition);
      } else {
        var range = document.createRange();
        var _char = caretPosition,
          _sel;
        if (document.selection) {
          _sel = document.selection.createRange();
          _sel.moveStart('character', _char);
          _sel.select();
        } else {
          _sel = window.getSelection();
          console.log('char:', _char);
          console.log('this.ref.lastChild.length', this.ref.lastChild.length);
          console.log(this.ref.lastChild.length);
          if (_char > this.ref.lastChild.length) {
            _sel.collapse(this.ref.lastChild, this.ref.lastChild.length);
          } else {
            _sel.collapse(this.ref.lastChild, _char);
          }
        }
      }
      this.closeMenu();
      this.ref.focus();
    }
  }, {
    key: "onInput",
    value: function () {
      var _onInput = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(ev) {
        var _this$options,
          _this2 = this;
        var positionIndex, text, textBeforeCaret, tokens, lastToken, triggerIdx, maybeTrigger, keystrokeTriggered, query, coords, boundPos;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              /*  
                This will apparently be undefined for <div>s, but the slice just
                returns the entire text.
              */
              positionIndex = this.ref.selectionStart;
              text = '';
              if (this.inputType == 'div') {
                // Should drop the <br> from Firefox
                text = this.ref.innerText.trim();
              } else {
                text = this.ref.value;
              }
              textBeforeCaret = text.slice(0, positionIndex);
              tokens = textBeforeCaret ? textBeforeCaret.split(/\s+/) : [];
              lastToken = tokens.pop();
              triggerIdx = textBeforeCaret.endsWith(lastToken) ? textBeforeCaret.length - lastToken.length : -1;
              maybeTrigger = textBeforeCaret[triggerIdx];
              keystrokeTriggered = maybeTrigger === '@';
              if (keystrokeTriggered) {
                _context.n = 1;
                break;
              }
              this.closeMenu();
              return _context.a(2);
            case 1:
              query = textBeforeCaret.slice(triggerIdx + 1);
              _context.n = 2;
              return this.resolveFn(query);
            case 2:
              this.options = _context.v;
              if ((_this$options = this.options) !== null && _this$options !== void 0 && _this$options.length) {
                coords = this.getCaretCoordinates(this.ref, positionIndex);
                boundPos = this.ref.getBoundingClientRect();
                this.top = 0;
                this.left = 0;
                setTimeout(function () {
                  _this2.active = 0;
                  _this2.triggerIdx = triggerIdx;
                  _this2.renderMenu(boundPos, coords);
                }, 1);
              } else {
                this.closeMenu();
              }
            case 3:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function onInput(_x) {
        return _onInput.apply(this, arguments);
      }
      return onInput;
    }()
  }, {
    key: "onKeyDown",
    value: function onKeyDown(ev) {
      var keyCaught = false;
      if (this.triggerIdx !== undefined) {
        switch (ev.key) {
          case 'ArrowDown':
            this.active = Math.min(this.active + 1, this.options.length - 1);
            this.renderMenu();
            keyCaught = true;
            break;
          case 'ArrowUp':
            this.active = Math.max(this.active - 1, 0);
            this.renderMenu();
            keyCaught = true;
            break;
          case 'Enter':
          case 'Tab':
            this.selectItem(this.active);
            keyCaught = true;
            break;
          case 'Escape':
            this.closeMenu();
            break;
        }
      }
      if (keyCaught) {
        ev.preventDefault();
      }
    }
  }, {
    key: "resolveFn",
    value: function resolveFn(prefix) {
      var users = this.app.keychain.returnKeys(null, false);
      if (!prefix) {
        return users;
      } else {
        return users.filter(function (user) {
          if (user !== null && user !== void 0 && user.identifier) {
            return user.identifier.toLowerCase().startsWith(prefix.toLowerCase());
          } else {
            return user.publicKey.toLowerCase().startsWith(prefix.toLowerCase());
          }
        });
      }
    }
  }, {
    key: "renderMenu",
    value: function renderMenu() {
      var _this3 = this;
      var boundPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var coords = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      if (!this.options.length) {
        this.menuRef.hidden = true;
        this.menuRef.setAttribute('status', 'hidden');
        this.menuRef.classList.add('hidden');
        return;
      } else {
        this.menuRef.setAttribute('status', 'show');
        this.menuRef.classList.remove('hidden');
        this.menuRef.hidden = false;
      }
      this.menuRef.style.left = this.left + 'px';
      this.menuRef.style.top = this.top + 'px';
      this.menuRef.innerHTML = '';
      this.options.forEach(function (option, idx) {
        _this3.menuRef.appendChild(_this3.addMenuItem(option, idx));
      });
      if (boundPos != null || coords != null) {
        var offsetTop = 10;
        if (this.inputType != 'div') {
          this.left = window.scrollX + coords.left + this.ref.scrollLeft;
          this.top = window.scrollY + coords.top + coords.height - this.ref.scrollTop;
        } else {
          var menuStyles = getComputedStyle(this.menuRef);
          var listWidth = Number(menuStyles.width.split('px')[0]);
          var listHeight = Number(menuStyles.height.split('px')[0]);
          var inputStyles = getComputedStyle(this.ref);
          var inputWidth = Number(inputStyles.width.split('px')[0]);
          var inputHeight = Number(inputStyles.height.split('px')[0]);
          var listPosX = 0;
          var listPosY = 0;
          if (listWidth + boundPos.left > window.innerWidth) {
            var widthDiff = listWidth + boundPos.left - window.innerWidth;
            listPosX = 0 - widthDiff;
          } else {
            listPosX = 0;
          }
          listPosY = -listHeight - offsetTop;
          this.left = listPosX;
          this.top = listPosY;
        }
        this.menuRef.style.left = this.left + 'px';
        this.menuRef.style.top = this.top + 'px';
      } else {
        // Need to check if we are using keys to scroll down
        var selec = this.menuRef.querySelector('.menu-item.selected');
        if (selec) {
          if (selec.getBoundingClientRect().bottom > this.menuRef.getBoundingClientRect().bottom) {
            selec.scrollIntoView(false);
          }
          if (selec.getBoundingClientRect().top < this.menuRef.getBoundingClientRect().top) {
            selec.scrollIntoView();
          }
        }
      }
    }
  }, {
    key: "addMenuItem",
    value: function addMenuItem(user, idx) {
      var _this4 = this;
      var parentDiv = document.createElement('div');
      parentDiv.classList.add('saito-mentions-contact');

      // identifier
      if (!(user !== null && user !== void 0 && user.identicon)) {
        user.identicon = this.app.keychain.returnIdenticon(user.publicKey);
      }
      var identicon = document.createElement('img');
      identicon.classList.add('saito-identicon');
      identicon.setAttribute('src', user.identicon);
      parentDiv.appendChild(identicon);

      // username div
      var div = document.createElement('div');
      div.setAttribute('role', 'option');
      div.className = 'menu-item';
      if (idx === this.active) {
        div.classList.add('selected');
        div.setAttribute('aria-selected', '');
      }
      if (user !== null && user !== void 0 && user.identifier) {
        div.textContent = user.identifier;
      } else {
        div.textContent = user.publicKey;
      }
      parentDiv.appendChild(div);
      parentDiv.onclick = function () {
        _this4.selectItem(idx);
      };
      return parentDiv;
    }
  }, {
    key: "getCaretCoordinates",
    value: function getCaretCoordinates(element, position) {
      var div = document.createElement('div');
      document.body.appendChild(div);
      var style = div.style;
      var computed = getComputedStyle(element);
      style.whiteSpace = 'pre-wrap';
      style.wordWrap = 'break-word';
      style.position = 'absolute';
      style.visibility = 'hidden';
      this.properties.forEach(function (prop) {
        style[prop] = computed[prop];
      });
      if (this.isFirefox) {
        if (element.scrollHeight > parseInt(computed.height)) style.overflowY = 'scroll';
      } else {
        style.overflow = 'hidden';
      }
      var text = '';
      if (this.inputType == 'div') {
        text = element.innerText;
      } else {
        text = element.value;
      }
      div.textContent = text.substring(0, position);
      var span = document.createElement('span');
      span.textContent = text.substring(position) || '.';
      div.appendChild(span);
      var coordinates = {
        top: span.offsetTop + parseInt(computed['borderTopWidth']),
        left: span.offsetLeft + parseInt(computed['borderLeftWidth']),
        // height: parseInt(computed['lineHeight'])
        height: span.offsetHeight
      };
      div.remove();
      return coordinates;
    }
  }]);
}();
module.exports = SaitoMentions;